import { useEffect, useState } from 'react';
import { Select, Skeleton } from '@backstage/ui';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';

export const DomainSelectField = ({
    onChange, formData, schema, required }: FieldExtensionComponentProps<string>) => {

    const catalogApi = useApi(catalogApiRef);
    const label = schema.title ?? 'Domain';
    const [items, setItems] = useState<{ label: string; id: string }[]>();

    useEffect(() => {
      const fetchDomains = async () => {
        const res = await catalogApi.getEntities({ filter: { kind: 'Domain', 'metadata.namespace': 'default' } });
        setItems(
          res.items.map(e => ({
            label: e.metadata.title ?? e.metadata.name,
            id: e.metadata.name,
          })),
        );
      };
      fetchDomains();
    }, [catalogApi]);

    if (!items) return <Skeleton />;

    return (
      <Select
        label={label}
        isRequired={required}
        selectedKey={formData ?? ''}
        onSelectionChange={key => onChange(key as string)}
        options={items}
      />
    );
};
